appSocial.component('leaderStat', {
    templateUrl: 'widgets/leader-detail/components/leader-stat/LeaderStatComponent.html',
    bindings: {
        trader: '<'
    },
    controller: [
        'SocialUserService',
        'SocialLocaleService',
        'SocialUtils',
        'SocialTypes',
        'SocialAPIService',
        'SocialThemeService',
        'moment',
        class LeaderStatComponent {
            constructor(
                SocialUserService,
                SocialLocaleService,
                SocialUtils,
                SocialTypes,
                SocialAPIService,
                SocialThemeService,
                moment
            ) {

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;

                /**
                 * @type {SocialThemeService}
                 */
                this.themeService = SocialThemeService;

                this.types = SocialTypes;

                this.moment = moment;

                this.translation = SocialLocaleService.translation;


                this.investedCapitalChartOptions = null;
                this.copiersChartOptions = null;
                this.viewsChartOptions = null;

                this.currentPopularity = 0;
                this.currentInvestedCapital = 0;
                this.currentCopiersNumber = 0;
            }

            $onInit() {
                this.update()
            }

            $onChanges(changes) {
                //console.log('trader changes', this.trader)
            }

            $onDestroy() {
            }

            getDailyData() {
                const request = {
                    _url: '/' + this.trader.id,
                    from: this.moment(Date.now()).utc(true).startOf('year').unix(),
                    to: this.moment().utc(true).unix(),
                };
                return this.api.request.getDailyData(request)
                    .then((response) => response.data);
            }

            update() {
                const {ChartType} = this.types;

                return Promise.all([
                    this.getDailyData()
                ])
                    .then(([dailyResponse]) => {
                        // Invested capital
                        const investedCapitalData = dailyResponse.map((item) => item.invested_capital);
                        this.investedCapitalChartOptions = this.createLineChart(
                            ChartType.InvestedCapital,
                            // labels
                            investedCapitalData.slice(Math.max(investedCapitalData.findIndex(item => item > 0) - 1, 0), investedCapitalData.length - 1)
                        );

                        this.currentInvestedCapital = dailyResponse[dailyResponse.length - 1].invested_capital;

                        // Copiers
                        const copiersData = dailyResponse.map((item) => item.followers_count);
                        this.copiersChartOptions = this.createLineChart(
                            ChartType.Copiers,
                            // labels
                            copiersData.slice(copiersData.findIndex(item => item > 0) - 1, copiersData.length - 1)
                        );
                        this.currentCopiersNumber = dailyResponse[dailyResponse.length - 1].followers_count;

                        this.areChartsVisible = !!investedCapitalData.find((item) => item) || !!copiersData.find((item) => item);

                        // Views
                        const popularityData = dailyResponse.map((item) => item.views);
                        this.viewsChartOptions = this.createLineChart(
                            ChartType.Views,
                            // labels
                            popularityData.slice(popularityData.findIndex(item => item > 0) - 1, popularityData.length - 1)
                        );
                        this.currentPopularity = dailyResponse.reduce((acc, cur) => acc + cur.views, 0);
                    })
            }

            createLineChart(type, series = []) {
                const {ChartType} = this.types;

                const gradient = {
                    from: '#cecece',
                    to: '#cecece'
                };
                let lineColor = 'gray';

                switch (type) {
                    case ChartType.InvestedCapital:
                        gradient.from = this.themeService.getThemeColor('leader-stats', 'gradientInvestedCapitalFrom');
                        gradient.to = this.themeService.getThemeColor('leader-stats', 'gradientInvestedCapitalTo');
                        lineColor = this.themeService.getThemeColor('leader-stats', 'colorInvestedCapitalLine');
                        break;
                    case ChartType.Copiers:
                        gradient.from = this.themeService.getThemeColor('leader-stats', 'gradientCopiersFrom');
                        gradient.to = this.themeService.getThemeColor('leader-stats', 'gradientCopiersTo');
                        lineColor = this.themeService.getThemeColor('leader-stats', 'colorCopiersLine');
                        break;
                    case ChartType.Views:
                        gradient.from = this.themeService.getThemeColor('leader-stats', 'gradientViewsFrom');
                        gradient.to = this.themeService.getThemeColor('leader-stats', 'gradientViewsTo');
                        lineColor = this.themeService.getThemeColor('leader-stats', 'colorViewsLine');
                        break;
                }

                const bgGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: gradient.from
                }, {
                    offset: 1,
                    color: gradient.to
                }]);

                return {
                    grid: {
                        top: '1%',
                        left: '1%',
                        right: '1%',
                        bottom: '1%',
                    },
                    xAxis: {
                        show: false,
                        type: 'category',
                        data: series
                    },
                    yAxis: {
                        show: false,
                        type: 'value'
                    },
                    // tooltip: {},
                    series: [
                        {
                            animationDuration: 300,
                            symbolSize: 0,
                            data: series,
                            type: 'line',
                            lineStyle: {
                                color: lineColor,
                                width: 2,
                                type: 'solid'
                            },
                            areaStyle: {
                                color: bgGradient
                            },
                            markPoint: {
                                symbol: 'circle',
                                symbolSize: 7,
                                data: [
                                    {name: '', xAxis: series.length - 1, yAxis: series[series.length - 1]}
                                ],
                                itemStyle: {
                                    color: lineColor
                                }
                            }
                        }
                    ]
                };

            }

        }]
})
